import React from "react";
import { CoachFooter } from "./CoachFooter";
import { CoachUserHeader } from "./CoachUserHeader";

const CoachLayout = ({ children }) => {
  return (
    <div className="overflow-hidden h-dvh">
      {/* <div className="p-5 overflow-hidden"> */}
      {/* <div className="p-5 h-dvh overflow-hidden"> */}
      <CoachUserHeader />
      <main className="overflow-y-auto bg-black footer-calc">
        {/* <main className="overflow-y-auto footer-calc"> */}
        {children}
      </main>
      <CoachFooter />
    </div>
  );
};

export default CoachLayout;
